import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import FilterIcon from '../../assets/icons/FilterIcon';
import Search from '../../assets/icons/search';
import * as css from './SearchFilterBar.css';

type Props = {
    search: string;
    onSearch: (value: string) => void;
    onFilter?: () => void;
    filterDisabled?: boolean;
    dataCy?: string;
};

const SearchFilterBar = ({search, onSearch, onFilter, filterDisabled, dataCy = 'searchFilter'}: Props) => {
    const {t} = useTranslation('timetable');

    return (
        <css.bar>
            <Button
                variant="neutral"
                size="category"
                iconStart={<FilterIcon width={20} height={20} />}
                onClick={onFilter}
                disabled={filterDisabled}
                data-cy={`${dataCy}-filter`}
            >
                {t('filter')}
            </Button>
            <css.searchPill data-cy={`${dataCy}-search`}>
                <css.searchInput
                    type="text"
                    value={search}
                    onChange={e => onSearch(e.target.value)}
                    placeholder={t('search')}
                    aria-label={t('search')}
                />
                <Search />
            </css.searchPill>
        </css.bar>
    );
};

export default SearchFilterBar;
